/* Avaza Candy theme JS — cart drawer, AJAX cart, variant picker, menus */
(function () {
  'use strict';

  var moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
  var freeShippingThreshold = window.theme && window.theme.freeShippingThreshold ? window.theme.freeShippingThreshold : 0;
  var flatShippingRate = window.theme && window.theme.flatShippingRate ? window.theme.flatShippingRate : 0;

  function formatMoney(cents) {
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (cents / 100).toFixed(2).replace('.', ','));
  }

  /* ---------- Toast ---------- */
  var toastEl = document.createElement('div');
  toastEl.className = 'toast';
  toastEl.setAttribute('role', 'status');
  document.body.appendChild(toastEl);
  var toastTimer;
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- Drawer helpers ---------- */
  var lastFocused = null;
  function openLayer(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var toggle = document.querySelector('[aria-controls="' + el.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var toggle = document.querySelector('[aria-controls="' + el.id + '"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
  }

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.getElementById('MobileMenu');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) openLayer(mobileMenu);
    if (e.target.closest('[data-menu-close]') || (mobileMenu && e.target === mobileMenu.querySelector('.mobile-menu__overlay'))) closeLayer(mobileMenu);
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');

  function renderCart(cart) {
    if (!cartDrawer) return;
    var itemsEl = cartDrawer.querySelector('[data-cart-items]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var subtotalEls = cartDrawer.querySelectorAll('[data-cart-subtotal]');
    var titleCount = cartDrawer.querySelector('[data-cart-title-count]');
    var footEl = cartDrawer.querySelector('[data-cart-foot]');
    var emptyEl = cartDrawer.querySelector('[data-cart-empty]');

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    if (titleCount) titleCount.textContent = '(' + cart.item_count + ')';
    subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.items_subtotal_price); });

    // Flat-rate shipping, free once the threshold is reached (both from theme settings)
    var freeShip = (cart.items_subtotal_price >= freeShippingThreshold && freeShippingThreshold > 0) || cart.item_count === 0;
    var shipCents = freeShip ? 0 : flatShippingRate;
    var shipEl = cartDrawer.querySelector('[data-cart-shipping]');
    if (shipEl) shipEl.textContent = freeShip ? 'Free' : (flatShippingRate > 0 ? formatMoney(shipCents) : 'At checkout');
    var totalEls = cartDrawer.querySelectorAll('[data-cart-total]');
    totalEls.forEach(function (el) { el.textContent = formatMoney(cart.items_subtotal_price + shipCents); });

    var remaining = (freeShippingThreshold || 0) - cart.items_subtotal_price;

    // Free-shipping progress bar
    var shipBox = cartDrawer.querySelector('[data-ship-progress]');
    if (shipBox && freeShippingThreshold > 0) {
      var pct = Math.min(100, (cart.items_subtotal_price / freeShippingThreshold) * 100);
      var fill = shipBox.querySelector('[data-ship-fill]');
      var label = shipBox.querySelector('[data-ship-label]');
      var meter = shipBox.querySelector('[data-ship-meter]');
      if (fill) fill.style.width = pct + '%';
      if (meter) meter.setAttribute('aria-valuenow', Math.round(pct));
      if (label) {
        label.innerHTML = remaining > 0
          ? 'Add <strong>' + formatMoney(remaining) + '</strong> for free shipping'
          : 'Free shipping unlocked';
      }
      shipBox.classList.toggle('is-unlocked', remaining <= 0);
      shipBox.style.display = cart.item_count > 0 ? '' : 'none';
    }

    // Add-on suggestions — only while the threshold is still out of reach
    var addons = cartDrawer.querySelector('[data-cart-addons]');
    if (addons) {
      var showAddons = cart.item_count > 0 && freeShippingThreshold > 0 && remaining > 0;
      addons.style.display = showAddons ? '' : 'none';
    }

    if (emptyEl && footEl && itemsEl) {
      var hasItems = cart.item_count > 0;
      emptyEl.style.display = hasItems ? 'none' : '';
      footEl.style.display = hasItems ? '' : 'none';
      itemsEl.style.display = hasItems ? '' : 'none';
    }

    // Free shipping bar
    var bar = cartDrawer.querySelector('[data-shipping-bar]');
    if (bar && freeShippingThreshold > 0) {
      var remaining = freeShippingThreshold - cart.items_subtotal_price;
      var fill = bar.querySelector('.shipping-bar__fill');
      var label = bar.querySelector('[data-shipping-label]');
      var pct = Math.min(100, (cart.items_subtotal_price / freeShippingThreshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (label) {
        label.innerHTML = remaining > 0
          ? "You're <em>" + formatMoney(remaining) + '</em> from complimentary shipping'
          : 'You have unlocked complimentary shipping';
      }
      bar.style.display = cart.item_count > 0 ? '' : 'none';
    }

    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var img = item.image
          ? '<img src="' + escapeHtml(item.image + (item.image.indexOf('?') > -1 ? '&width=180' : '?width=180')) + '" alt="" loading="lazy" width="74" height="74">'
          : '';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : (item.product_type || '');
        return (
          '<div class="cart-line" data-line="' + (i + 1) + '" data-key="' + escapeHtml(item.key) + '">' +
            '<div class="cart-line__img">' + img + '</div>' +
            '<div class="cart-line__body">' +
              '<div class="cart-line__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></div>' +
              (variantTitle ? '<div class="cart-line__variant">' + escapeHtml(variantTitle) + '</div>' : '<div class="cart-line__variant"></div>') +
              '<div class="cart-line__row">' +
                '<div class="qty-stepper">' +
                  '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
                  '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
                  '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="cart-line__remove" data-remove-line>Remove</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function addToCart(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    // Open / close cart drawer
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      fetchCart().then(renderCart);
      openLayer(cartDrawer);
    }
    if (e.target.closest('[data-cart-close]') || (cartDrawer && e.target === cartDrawer.querySelector('.cart-drawer__overlay'))) {
      closeLayer(cartDrawer);
    }

    // Quick add from product cards
    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      var variantId = quickAdd.getAttribute('data-quick-add');
      quickAdd.disabled = true;
      addToCart({ id: parseInt(variantId, 10), quantity: 1 })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          renderCart(cart);
          openLayer(cartDrawer);
        })
        .catch(function (err) { toast(err.description || 'Could not add to bag'); })
        .finally(function () { quickAdd.disabled = false; });
    }

    // Cart line qty +/- and remove
    var line = e.target.closest('.cart-line');
    if (line) {
      var lineIndex = parseInt(line.getAttribute('data-line'), 10);
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var input = line.querySelector('[data-qty-input]');
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        changeLine(lineIndex, next);
      }
      if (e.target.closest('[data-remove-line]')) changeLine(lineIndex, 0);
    }

    // Generic +/- steppers (product page)
    var stepBtn = e.target.closest('[data-step]');
    if (stepBtn) {
      var wrap = stepBtn.closest('.qty-stepper');
      var inp = wrap && wrap.querySelector('input');
      if (inp) {
        var v = Math.max(parseInt(inp.min || '1', 10), (parseInt(inp.value, 10) || 1) + parseInt(stepBtn.getAttribute('data-step'), 10));
        inp.value = v;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('.cart-line [data-qty-input]')) {
      var line = e.target.closest('.cart-line');
      changeLine(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
  });

  /* Cart note autosave (drawer) */
  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteTimer);
    var value = e.target.value;
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: value })
      }).then(function (r) {
        if (!r.ok) return;
        var saved = document.querySelector('[data-note-saved]');
        if (saved) {
          saved.classList.add('is-visible');
          setTimeout(function () { saved.classList.remove('is-visible'); }, 1500);
        }
      });
    }, 600);
  });

  /* Esc closes layers */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLayer(cartDrawer); closeLayer(mobileMenu); }
  });

  /* ---------- Product form (main product page) ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var productJsonEl = document.getElementById('ProductJson');
    var productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    var priceEl = document.querySelector('[data-product-price]');
    var comparePriceEl = document.querySelector('[data-product-compare]');
    var stickyPriceEl = document.querySelector('[data-sticky-price]');
    var idInput = productForm.querySelector('input[name="id"]');
    var atcButtons = document.querySelectorAll('[data-atc]');

    /* Gallery slider (swipe on mobile, arrows on desktop) */
    var galleryTrack = document.querySelector('[data-gallery-track]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function currentSlideIndex() {
      if (!galleryTrack || !galleryTrack.clientWidth) return 0;
      return Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
    }

    function setGalleryActive(i) {
      document.querySelectorAll('.gallery-dot').forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
      });
      document.querySelectorAll('.product-gallery__thumbs [data-goto]').forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-goto'), 10) === i);
      });
    }

    function goToSlide(i) {
      if (!galleryTrack) return;
      var slides = galleryTrack.children;
      if (!slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      galleryTrack.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      setGalleryActive(i);
    }

    if (galleryTrack) {
      var gallerySyncPending = false;
      galleryTrack.addEventListener('scroll', function () {
        if (gallerySyncPending) return;
        gallerySyncPending = true;
        requestAnimationFrame(function () {
          gallerySyncPending = false;
          setGalleryActive(currentSlideIndex());
        });
      }, { passive: true });

      galleryTrack.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(currentSlideIndex() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(currentSlideIndex() + 1); }
      });

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-gallery-prev]')) goToSlide(currentSlideIndex() - 1);
        if (e.target.closest('[data-gallery-next]')) goToSlide(currentSlideIndex() + 1);
        var goto = e.target.closest('[data-goto]');
        if (goto) goToSlide(parseInt(goto.getAttribute('data-goto'), 10));
      });
    }

    function currentVariant() {
      if (!productData) return null;
      var selected = [];
      productForm.querySelectorAll('.variant-fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      if (!selected.length) return productData.variants[0];
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      }) || null;
    }

    function updateVariantUI() {
      var variant = currentVariant();
      if (!variant) {
        atcButtons.forEach(function (b) { b.disabled = true; b.querySelector('[data-atc-label]').textContent = 'Unavailable'; });
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      atcButtons.forEach(function (b) {
        b.disabled = !variant.available;
        var label = b.querySelector('[data-atc-label]');
        if (label) label.textContent = variant.available ? 'Add to bag' : 'Sold out';
      });
      if (variant.featured_image && typeof variant.featured_image.position === 'number') {
        goToSlide(variant.featured_image.position - 1);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    productForm.addEventListener('change', function (e) {
      if (e.target.matches('.variant-pill input')) updateVariantUI();
    });

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(productForm);
      var submitBtns = document.querySelectorAll('[data-atc]');
      submitBtns.forEach(function (b) { b.disabled = true; });
      addToCart({ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderCart(cart); openLayer(cartDrawer); })
        .catch(function (err) { toast((err && err.description) || 'Could not add to bag'); })
        .finally(function () { submitBtns.forEach(function (b) { b.disabled = false; }); });
    });

    // Sticky ATC bar visibility on mobile
    var stickyBar = document.querySelector('.sticky-atc');
    var buyRow = document.querySelector('.buy-row');
    if (stickyBar && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(buyRow);
    }

  }

  /* ---------- Welcome popup ---------- */
  var welcomePopup = document.getElementById('WelcomePopup');
  if (welcomePopup) {
    var POPUP_KEY = 'avaza_welcome_popup';
    var popupState = null;
    try { popupState = JSON.parse(localStorage.getItem(POPUP_KEY)); } catch (e) {}
    function savePopupState(s) {
      try { localStorage.setItem(POPUP_KEY, JSON.stringify({ s: s, t: Date.now() })); } catch (e) {}
    }
    var popupDone = popupState && popupState.s === 'done';
    var popupDismissed = popupState && popupState.s === 'dismissed' &&
      (Date.now() - popupState.t) < 1000 * 60 * 60 * 24 * 15;
    var justPosted = window.location.search.indexOf('customer_posted=true') > -1;
    var hasFormError = !!welcomePopup.querySelector('[data-popup-error]');

    if (justPosted) {
      var formView = welcomePopup.querySelector('[data-popup-form-view]');
      var successView = welcomePopup.querySelector('[data-popup-success-view]');
      if (formView) formView.style.display = 'none';
      if (successView) successView.style.display = '';
      popupDone = true;
      savePopupState('done');
      openLayer(welcomePopup);
    } else if (hasFormError) {
      openLayer(welcomePopup);
    } else if (!popupDone && !popupDismissed) {
      // Never interrupt someone who is already buying
      var onCheckoutPath = /\/(cart|checkout)/.test(window.location.pathname);
      var popupShown = false;

      function tryOpenPopup() {
        if (popupShown || onCheckoutPath) return;
        var cartOpen = cartDrawer && cartDrawer.classList.contains('is-open');
        var menuOpen = mobileMenu && mobileMenu.classList.contains('is-open');
        if (cartOpen || menuOpen) return;
        popupShown = true;
        openLayer(welcomePopup);
      }

      // Give people time to shop first: 40 s, or exit intent / a deep scroll, whichever comes first
      setTimeout(tryOpenPopup, 40000);

      // Exit intent: cursor leaves through the top of the window
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) tryOpenPopup();
      });

      // Mobile has no exit intent — catch a decisive scroll instead
      var scrollFired = false;
      window.addEventListener('scroll', function () {
        if (scrollFired) return;
        var seen = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
        if (seen > 0.55) { scrollFired = true; tryOpenPopup(); }
      }, { passive: true });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('#WelcomePopup [data-popup-close]')) {
        if (!popupDone) savePopupState('dismissed');
        closeLayer(welcomePopup);
      }
      var copyBtn = e.target.closest('[data-copy-code]');
      if (copyBtn && navigator.clipboard) {
        navigator.clipboard.writeText(copyBtn.getAttribute('data-copy-code'));
        copyBtn.textContent = 'Copied!';
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && welcomePopup.classList.contains('is-open')) {
        if (!popupDone) savePopupState('dismissed');
        closeLayer(welcomePopup);
      }
    });
  }

  /* ---------- Header stuck state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-stuck', window.scrollY > 4);
    }, { passive: true });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    setTimeout(function () { document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); }); }, 1500);
  }

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Predictive search ---------- */
  // Full results page: same field restriction as the suggestions, so both agree
  function searchPageUrl(term) {
    return '/search?q=' + encodeURIComponent(term) +
           '&type=product&options%5Bprefix%5D=last' +
           '&options%5Bfields%5D=title,product_type,tag,variants.title';
  }

  // suggest.json returns prices as dollar strings ("7.99"); the rest of the theme works in cents
  function suggestPriceToCents(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number') return Math.round(value * 100);
    var num = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    return isNaN(num) ? null : Math.round(num * 100);
  }

  function highlight(text, term) {
    var safe = escapeHtml(text);
    if (!term) return safe;
    var words = term.trim().split(/\s+/).filter(Boolean)
      .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
  }

  // Binds live suggestions to any container holding [data-search-input] + [data-search-results].
  // Used by the header panel and by the /search page form.
  function initPredictiveSearch(root, onEscape) {
    var searchInput = root.querySelector('[data-search-input]');
    var searchResults = root.querySelector('[data-search-results]');
    var searchQuick = root.querySelector('[data-search-quick]');
    if (!searchInput || !searchResults) return null;
    var searchTimer, searchController, activeIndex = -1;

    function hideResults() {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
      searchInput.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function renderResults(data, term) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
      var html = '';

      if (!products.length && !collections.length) {
        searchResults.innerHTML = '<div class="search-panel__empty">Nothing matched &ldquo;' +
          escapeHtml(term) + '&rdquo;. Try a shorter word — like <em>gummy</em> or <em>choc</em>.</div>';
        searchResults.hidden = false;
        return;
      }

      if (products.length) {
        html += '<div class="search-panel__group"><div class="search-panel__group-title">Products</div>';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') + '" alt="" loading="lazy">'
            : '';
          var minCents = suggestPriceToCents(p.price_min);
          var maxCents = suggestPriceToCents(p.price_max);
          var price = minCents != null ? formatMoney(minCents) : '';
          var prefix = (minCents != null && maxCents != null && maxCents > minCents) ? 'from ' : '';
          html += '<a class="search-hit" href="' + p.url + '" role="option">' +
                    '<span class="search-hit__img">' + img + '</span>' +
                    '<span class="search-hit__text">' +
                      '<span class="search-hit__title">' + highlight(p.title, term) + '</span>' +
                      (p.product_type ? '<span class="search-hit__meta">' + escapeHtml(p.product_type) + '</span>' : '') +
                    '</span>' +
                    (price ? '<span class="search-hit__price">' + prefix + price + '</span>' : '') +
                  '</a>';
        });
        html += '</div>';
      }

      if (collections.length) {
        html += '<div class="search-panel__group"><div class="search-panel__group-title">Collections</div>';
        collections.forEach(function (c) {
          html += '<a class="search-hit" href="' + c.url + '" role="option">' +
                    '<span class="search-hit__text"><span class="search-hit__title">' +
                      highlight(c.title, term) + '</span></span></a>';
        });
        html += '</div>';
      }

      html += '<a class="search-panel__all" href="' + searchPageUrl(term) + '">' +
                'See all results for &ldquo;' + escapeHtml(term) + '&rdquo;</a>';

      searchResults.innerHTML = html;
      searchResults.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function runSearch(term) {
      if (searchController) searchController.abort();
      searchController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
                '&resources[type]=product,collection' +
                '&resources[limit]=6' +
                '&resources[options][unavailable_products]=last' +
                '&resources[options][fields]=title,product_type,tag,variants.title';

      fetch(url, searchController ? { signal: searchController.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) { renderResults(data, term); })
        .catch(function (err) { if (!err || err.name !== 'AbortError') { searchResults.hidden = true; } });
    }

    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (searchQuick) searchQuick.style.display = term ? 'none' : '';
      if (term.length < 2) { hideResults(); return; }
      searchTimer = setTimeout(function () { runSearch(term); }, 180);
    });

    searchInput.addEventListener('keydown', function (e) {
      var hits = searchResults.querySelectorAll('.search-hit, .search-panel__all');
      if (e.key === 'Escape') {
        if (onEscape) { onEscape(); } else { hideResults(); }
        return;
      }
      if (!hits.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = e.key === 'ArrowDown'
          ? (activeIndex + 1) % hits.length
          : (activeIndex - 1 + hits.length) % hits.length;
        hits.forEach(function (h, i) { h.classList.toggle('is-active', i === activeIndex); });
        hits[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && activeIndex > -1) {
        e.preventDefault();
        window.location.href = hits[activeIndex].getAttribute('href');
      }
    });

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-search-term]');
      if (!chip) return;
      searchInput.value = chip.getAttribute('data-search-term');
      if (searchQuick) searchQuick.style.display = 'none';
      runSearch(searchInput.value);
      searchInput.focus();
    });

    return { input: searchInput, hide: hideResults, run: runSearch };
  }

  // Header search panel (toggle button in the nav)
  var searchPanel = document.getElementById('SearchPanel');
  if (searchPanel) {
    var headerSearch = initPredictiveSearch(searchPanel, closeSearch);

    function openSearch() {
      searchPanel.hidden = false;
      var toggle = document.querySelector('[data-search-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (headerSearch) headerSearch.input.focus(); }, 30);
    }
    function closeSearch() {
      searchPanel.hidden = true;
      if (headerSearch) headerSearch.hide();
      var toggle = document.querySelector('[data-search-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-toggle]')) {
        e.preventDefault();
        if (searchPanel.hidden) { openSearch(); } else { closeSearch(); }
        return;
      }
      if (e.target.closest('[data-search-close]')) { closeSearch(); return; }
      if (!searchPanel.hidden && !e.target.closest('#SearchPanel')) closeSearch();
    });
  }

  // /search page: suggestions drop down under the main search form
  var pageSearch = document.querySelector('[data-page-search]');
  if (pageSearch) {
    var pageSuggest = initPredictiveSearch(pageSearch, null);
    if (pageSuggest) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-page-search]')) pageSuggest.hide();
      });
    }
  }
})();


/* ---------- Footer trust strip: rotate short reviews ---------- */
(function () {
  var box = document.querySelector('[data-ftrust-quotes]');
  if (!box) return;
  var items = box.querySelectorAll('.ftrust__q');
  if (items.length < 2) return;
  var i = 0;
  setInterval(function () {
    items[i].classList.remove('is-on');
    i = (i + 1) % items.length;
    items[i].classList.add('is-on');
  }, 5000);
})();
